<template>
  <v-dialog v-if="dialog" v-model="dialog" persistent fullscreen>
    <v-toolbar dark color="#025464">
      <v-btn icon dark @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{
        completed ? '日誌紀錄 - ' + caseName : '填寫日誌 - ' + caseName
      }}</v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-card-title>
        <v-row dense>
          <v-col class="text-center" cols="12">
            <span>個案姓名: </span>
            <span class="font-weight-bold">{{ caseName }}</span>
          </v-col>
          <v-col class="text-center" cols="12">
            <span>紀錄日期: </span>
            <span>{{ date }}</span>
          </v-col>
          <v-col class="text-center" cols="12">
            <v-btn
              class="font-weight-bold black--text"
              color="#00e6a0"
              @click="getLastRecord(caseId)"
            >
              匯入前次紀錄
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-container>
            <v-row dense v-for="(item, key) in form" :key="key">
              <v-col cols="12">
                <span class="text-h5 font-weight-bold black--text">{{ item.question }}</span>
              </v-col>
              <v-col cols="12">
                <template v-if="item.options && item.options.length">
                  <v-btn-toggle dense v-model="item.answer" style="flex-wrap: wrap">
                    <v-btn
                      v-for="option in item.options"
                      :key="option"
                      :value="option"
                      color="#ffb200"
                      class="ma-1 text-h6 font-weight-bold"
                      active-class="selected-option"
                    >
                      {{ option }}
                    </v-btn>
                  </v-btn-toggle>
                </template>
                <v-textarea v-else dense filled clearable v-model="item.answer"></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="font-weight-bold black--text">傷口紀錄</span>
              </v-col>
              <v-col
                v-for="(image, index) in imagePreviews"
                :key="index"
                cols="6"
                sm="4"
                md="3"
                lg="2"
              >
                <div class="gallery-item">
                  <v-img :src="image" alt="Uploaded Image" max-width="100%" />
                </div>
              </v-col>
              <v-col cols="6" sm="4" md="3" lg="2">
                <div class="gallery-item">
                  <div class="upload-placeholder" @click="handleUpload">
                    <v-icon large>mdi-plus</v-icon>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-btn
              v-if="imagePreviews.length > 0"
              @click="submitUpload"
              color="primary"
              class="ma-2"
            >
              上傳測試
            </v-btn>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="pb-8">
        <v-row dense class="justify-space-around">
          <v-col cols="4">
            <v-btn dark block color="red darken-1" @click="closeDialog">取消</v-btn></v-col
          ><v-col cols="4">
            <v-btn dark block color="blue darken-1" @click="submitUpload">送出</v-btn></v-col
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    value: Boolean,
    caseName: String,
    date: String,
    caseId: String,
    staffId: String,
    completed: Boolean,
  },
  data() {
    return {
      isMobileDevice: false,
      imagePreviews: [],
      form: {},
      contents: {},
      record_id: '',
    }
  },
  methods: {
    async getQuestions() {
      let config = {
        method: 'get',
        url: `/api/journal/get_question`,
        header: {},
      }
      try {
        let res = await axios.request(config)
        this.contents = res.data.data
        this.resetForm()
      } catch (error) {
        console.log(error)
      }
    },
    async getRecord(case_num, date) {
      let config = {
        method: 'get',
        url: `/api/journal/search_record?case_num=${case_num}&date=${date}`,
        header: {},
      }
      try {
        let res = await axios.request(config)
        this.form = res.data.data
        this.record_id = res.data.data.record_id
      } catch (error) {
        console.log(error)
      }
    },
    async getLastRecord(case_num) {
      let config = {
        method: 'get',
        url: `/api/journal/search_latest_record?case_num=${case_num}`,
        header: {},
      }
      try {
        let res = await axios.request(config)
        const { record_id, ...others } = res.data.data
        this.form = others
        // console.log(this.form)
      } catch (error) {
        console.log(error)
      }
    },
    async makeRecord(case_num) {
      // console.log(`completed:${this.completed}`)
      let data = {}
      let config = {}
      if (this.completed) {
        data = JSON.stringify({
          case_num: case_num,
          employee_id: this.staffId,
          date: this.date,
          record_id: this.record_id,
          ...this.form,
        })
        config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: '/api/journal/edit_record',
          headers: {
            'Content-Type': 'application/json',
          },
          data: data,
        }
      } else {
        data = JSON.stringify({
          case_num: case_num,
          employee_id: this.staffId,
          date: this.date,
          ...this.form,
        })
        config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: '/api/journal/make_record',
          headers: {
            'Content-Type': 'application/json',
          },
          data: data,
        }
      }

      try {
        let res = await axios.request(config)
        // console.log(`${res.data.status}, ${res.data.data}`)
        this.$emit('get_list')
      } catch (error) {
        console.log(error)
      }
    },
    async makeWound(case_num) {
      let data = JSON.stringify({
        employee_id: this.staffId,
        date: this.date,
        images: this.imagePreviews,
      })
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `/api/attendance/wounds/${case_num}/`,
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      }
      try {
        let res = await axios.request(config)
        // console.log(res.data)
        this.imagePreviews = []
      } catch (error) {
        console.log(error)
      }
    },
    submitUpload() {
      this.makeRecord(this.caseId)
      this.makeWound(this.caseId)
      this.dialog = false
      this.resetForm()
    },
    handleUpload() {
      if (this.isMobileDevice) {
        this.openCamera()
      } else {
        this.openFilePicker()
      }
    },
    openFilePicker() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = (event) => {
        const file = event.target.files[0]
        this.previewImage(file)
      }
      input.click()
    },
    openCamera() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.capture = 'camera'
      input.onchange = (event) => {
        const file = event.target.files[0]
        this.previewImage(file)
      }
      input.click()
    },
    previewImage(file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imagePreviews.push(e.target.result)
      }
      reader.readAsDataURL(file)
    },
    resetForm() {
      this.form = JSON.parse(JSON.stringify(this.contents))
      this.imagePreviews = []
      this.record_id = ''
    },
    closeDialog() {
      this.dialog = false
      this.resetForm()
    },
  },
  mounted() {
    this.getQuestions()
  },
  computed: {
    dialog: {
      get() {
        if (this.value && this.completed) {
          this.getRecord(this.caseId, this.date)
        }
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>
<style scoped>
.selected-option {
  background-color: #0078ff !important;
  color: white !important;
}

.gallery-item {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #ccc;
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  cursor: pointer;
}

.upload-placeholder {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
